module.exports = __webpack_public_path__ + "static/ETCH_BADGE_THING-064ca546c889d288858534d98f61b0cd.gif";